import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '../../material-module';
import { ProgressDialogComponent } from './progress-dialog.component';
import { LottieComponent } from 'ngx-lottie';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    LottieComponent
  ],
  declarations: [ProgressDialogComponent],
  exports: [ProgressDialogComponent]
})
export class ProgressDialogModule { }
